import React from 'react';

import SystemIcon from '../images/icons/system.svg';
import OverviewIcon from '../images/icons/overview.svg';
import PipeIcon from '../images/icons/pipe.svg';
import SettingsDatahubIcon from '../images/icons/settings-datahub.svg';
import SettingsSubscriptionIcon from '../images/icons/settings-subscription.svg';
import GraphIcon from '../images/icons/graph.svg';
import MagnifyIcon from '../images/icons/magnify.svg';

import { NavBarItemNames } from '../constants/commonConstants';
import type { NavBarMenuItemGroup, NavBarMenuItemGroups } from '../types/common.types';

export const useNavBarLinks = (subId: string, connected: boolean): NavBarMenuItemGroups => {
  const settingsSubMenu: NavBarMenuItemGroup = {
    id: 'settingsSubMenu',
    label: 'Settings',
    items: [
      {
        id: 'datahub',
        to: `/subscription/${subId}/settings-datahub`,
        title: NavBarItemNames.Datahub,
        icon: <SettingsDatahubIcon />,
        disabled: !connected,
      },
      {
        id: 'subscription',
        to: `/subscription/${subId}/settings-subscription`,
        title: NavBarItemNames.Subscription,
        icon: <SettingsSubscriptionIcon />,
      },
    ],
  };

  const navLinks: NavBarMenuItemGroup = {
    id: 'navLinks',
    items: [
      {
        id: 'overview',
        to: `/subscription/${subId}/overview`,
        title: NavBarItemNames.Overview,
        icon: <OverviewIcon />,
        disabled: !connected,
      },
      {
        id: 'browse',
        to: `/subscription/${subId}/browse`,
        title: NavBarItemNames.Browse,
        icon: <MagnifyIcon />,
        disabled: !connected,
      },
      {
        id: 'pipes',
        to: `/subscription/${subId}/pipes`,
        title: NavBarItemNames.Pipes,
        icon: <PipeIcon />,
        disabled: !connected,
      },
      {
        id: 'systems',
        to: `/subscription/${subId}/systems`,
        title: NavBarItemNames.Systems,
        icon: <SystemIcon />,
        disabled: !connected,
      },
      {
        id: 'flows',
        to: `/subscription/${subId}/flows`,
        title: NavBarItemNames.Flows,
        icon: <GraphIcon />,
        disabled: !connected,
        new: true,
      },
    ],
  };

  return [navLinks, settingsSubMenu];
};
